import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "Creativo",
  icon: "✨",
  templates: [
    {
      title: "Storia della Buonanotte",
      content: `Crea una storia dolce della buonanotte per un bambino piccolo, scritta per essere letta ad alta voce.
- Il personaggio principale è [una piccola volpe gentile] di nome [Hazel].
- La storia è ambientata in [un accogliente villaggio nel bosco dove le lanterne brillano di notte].
- Il personaggio affronta una piccola sfida rassicurante: [non riesce a trovare la sua stella preferita nel cielo nuvoloso, così segue le lucciole fino alla cima di una collina].
- Concludi con una risoluzione pacifica che insegna [la pazienza e la fiducia che le cose belle sono ancora lì, anche quando non riesci a vederle].
- Usa frasi brevi e ritmiche che suonino naturali quando lette ad alta voce.`
    },
    {
      title: "Narrazione di Racconto Breve",
      content: `Scrivi un racconto breve adatto alla narrazione in stile audiolibro.
- Genere: [giallo contemporaneo].
- La protagonista è [una bibliotecaria in pensione che nota qualcosa di strano nella routine quotidiana del nuovo vicino].
- La tensione centrale sono [piccoli dettagli inspiegabili che si accumulano verso una rivelazione sorprendente ma soddisfacente].
- Tono: [suspense tranquilla con tocchi di calore].
- Scrivi con uno stile chiaro e scorrevole con lunghezze di frase variate per mantenere l'interesse dell'ascoltatore.`
    },
    {
      title: "Lettura di Poesia",
      content: `Scrivi una poesia pensata per essere recitata ad alta voce.
- Tema: [la sensazione di una città che si sveglia all'alba].
- Stile: [verso libero con un ritmo parlato naturale].
- Atmosfera: [riflessiva e piena di speranza].
- Includi dettagli sensoriali vividi: [il suono del primo autobus, la luce sul marciapiede bagnato, il profumo del pane appena sfornato da una panetteria].
- Usa pause e interruzioni di riga che guidino il ritmo e il respiro del lettore.`
    }
  ]
};
